"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PatientSchedulingPreferenceType_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var PatientSchedulingPreferenceType_Factory = /** @class */ (function () {
    function PatientSchedulingPreferenceType_Factory() {
    }
    PatientSchedulingPreferenceType_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            PreferenceType: model.PreferenceType,
            PreferenceTypeCode: model.PreferenceTypeCode,
        };
        return result;
    };
    PatientSchedulingPreferenceType_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            PreferenceType: model.PreferenceType,
            PreferenceTypeCode: model.PreferenceTypeCode,
        };
        return result;
    };
    return PatientSchedulingPreferenceType_Factory;
}());
exports.PatientSchedulingPreferenceType_Factory = PatientSchedulingPreferenceType_Factory;
